import { localisedValue } from "utils"

const feedbackOptionsTransformer = response => {
  return response?.data?.map(item => {
    return {
      ...item,
      label: localisedValue({ object: item, key: "name" }),
      value: item.id.toString(),
    }
  })
}

export default feedbackOptionsTransformer
